export default __webpack_public_path__ + "static/media/simurgh-grand.818579b0.jpg";